module.exports = __webpack_public_path__ + "static/media/add-enrollment-stem.019f0fad.png";